import script from "./PublicMaquinasView.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicMaquinasView.vue?vue&type=script&setup=true&lang=js"

import "./PublicMaquinasView.vue?vue&type=style&index=0&id=06a44c36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06a44c36"]])

export default __exports__